import { styled } from '@material-ui/core';

/** add border between items */
export const ContentContainer = styled('div')({});
